document.addEventListener('DOMContentLoaded', function () {
  const inquirySelect = document.getElementById('ContactForm-inquiry');
  const productInquiryWrapper = document.getElementById('ContactForm-product_inquiry_type');
  const productInquirySelect = document.getElementById('ContactForm-product-inquiry-type');
  const productFields = document.getElementById('product');
  const retailerFields = document.getElementById('retailer');

  if (!inquirySelect || !productInquiryWrapper || !productInquirySelect || !productFields || !retailerFields) return;

  // Step 1: Save original required state
  const allDynamicSections = [productInquiryWrapper, productFields, retailerFields];
  allDynamicSections.forEach((section) => {
    const inputs = section.querySelectorAll('input, select, textarea');
    inputs.forEach((input) => {
      input.dataset.originalRequired = input.hasAttribute('required') ? 'true' : 'false';
    });
  });

  // Step 2: Toggle visibility and required status
  function toggleSection(element, show) {
    element.style.display = show ? '' : 'none';
    const inputs = element.querySelectorAll('input, select, textarea');
    inputs.forEach((input) => {
      const wasOriginallyRequired = input.dataset.originalRequired === 'true';
      if (show && wasOriginallyRequired) {
        input.setAttribute('required', 'required');
      } else {
        input.removeAttribute('required');
      }
    });
  }

  function updateVisibility() {
    const inquiryVal = inquirySelect.value;
    const productSubVal = productInquirySelect.value;

    const isProduct = inquiryVal === 'Product';
    const isRetailer = inquiryVal === 'RetailerOrDistribution';

    toggleSection(productInquiryWrapper, isProduct);
    toggleSection(retailerFields, isRetailer);
    toggleSection(productFields, isProduct && productSubVal);
  }

  // Initial run
  updateVisibility();

  // Event listeners
  inquirySelect.addEventListener('change', function () {
    productInquirySelect.value = '';
    updateVisibility();
  });

  productInquirySelect.addEventListener('change', updateVisibility);
});

document.getElementById('ContactForm').addEventListener('submit', function (event) {
  event.preventDefault(); // Prevent the default form submission
  event.stopImmediatePropagation();

  const form = event.target;
  const data = {
    AgeGroupId: "3", // Over 35
    ConsumerEmailAddress: form['ConsumerEmailAddress'].value,
    FirstName: form['FirstName'].value,
    LastName: form['LastName'].value,
    Address1: form['Address1'].value,
    Address2: form['Address2'].value,
    City: form['City'].value,
    StateCode: form['StateCode'].value,
    PostalCode: form['PostalCode'].value,
    PhoneNumber: form['PhoneNumber'].value,
    Comments: form['Comments'].value,
    ExtendedProperties: {}
  };

  const inquireType = form['InquiryType'].value;
  const productInquiryType = form['ProductInquiryType'].value;
  data['ExtendedProperties']['InquiryType'] = inquireType;
  if (inquireType === 'Product') {
    data['ExtendedProperties']['ProductInquiryType'] = productInquiryType;
    data['ProductName'] = form['ProductName'].value;
    data['Upc'] = form['Upc'].value;
    data['PackageCode'] = form['PackageCode'].value;
    //data['StoreName'] = form['StoreName'].value;
    //data['StoreLocation'] = form['StoreLocation'].value;
    //data['ExtendedProperties']['StoreState'] = form['StoreState'].value;
  } else if (inquireType === 'RetailerOrDistribution') {
    data['StoreName'] = form['RetailerStoreName'].value;
    data['StoreLocation'] = form['RetailerStoreLocation'].value;
    data['ExtendedProperties']['StoreState'] = form['RetailerStoreState'].value;
    data['ExtendedProperties']['NewOrExisting'] = form['NewOrExisting'].value;
  }

  const files = form['ImageFiles'].files;
  const formData = new FormData();
  for (let i = 0; i < files.length; i++)
    formData.append('Attachments', files[i]);
  formData.append('body', JSON.stringify(data));

  form.querySelectorAll('.error-message').forEach(el => {
    const p = el.closest('fieldset');
    p.classList.remove('error-field');
    p.querySelector('.error-message').textContent = '';
  });

  fetch('https://apigeex2.juicyorange.com/edgard-cooper/contactus/submit', {
    method: 'POST',
    body: formData
  })
    .then(r => r.json())
    .then(data => {
      if (data.errors) {
        for (let k in data.errors) {
          const p = form[k];
          if (p) {
            const parent = p.closest('fieldset');
            parent.classList.add('error-field');
            let errText = parent.querySelector('.error-message');
            if (!errText) {
              errText = document.createElement('div');
              errText.className = 'error-message';
              parent.appendChild(errText);
            }
            errText.textContent = data.errors[k].join(', ');
          }
        }
      }
      console.log(data);

      if (data.statusCode === 200) {
        form.reset();
        document.querySelector('.success-message').style.display = 'block';
      }
    })
    .catch(error => {
      alert('There was a problem with your submission: ' + error.message);
    });
});
